
	export default {
		name: 'LeftSection',
		props: {
			itemids: {
				type: Array,
				required: false
			}
		},
		data(){
			return {
				items: false,
				monthlyCost: 0,
				saleText: ``,
			}
		},
		async created(){
			if(this.itemids){
				const cart = await this.$member.cart.setItems(this.itemids);
				try {
					this.items = cart.data.member.cart.items
					for(let i = 0; i < this.items.length; i++){
						this.monthlyCost = ((this.items[i].sale_price ? this.items[i].sale_price : this.items[i].list_price) / 12).toFixed(2)
						this.saleText = this.items[i].sale_price < 99 ? `$` + this.items[i].sale_price  + ` for the first year, $99 renewal rate.` : `$` + this.items[i].sale_price + ` Billed Annually`
					}
				} catch(err){
					console.log(err)
				}
				console.log('my cart items are', cart)
			}
		}
	};
